// usersApi.js
import { BASE_URL, HEADERS } from "./config";

export const fetchUsers = async (page = 1, limit = 20) => {
    const API_URL = `${BASE_URL}/users/list?page=${page}&limit=${limit}`;

    try {
        const response = await fetch(API_URL, {
            method: "GET",
            headers: HEADERS,
        });

        if (!response.ok) {
            throw new Error(`Failed to fetch users: ${response.statusText}`);
        }

        const data = await response.json();
        
        console.log("✅ API Response:", data); // Debugging log

        return {
            users: Array.isArray(data.data.users) ? data.data.users : [], // Ensure users is always an array
            totalPages: data.data.totalPages || 1,
        };
    } catch (error) {
        console.error("Error fetching users:", error);
        return { users: [], totalPages: 1 };
    }
};


export const addUser = async (userData) => {
    const API_URL = BASE_URL + "/users/createZap";

    try {
        const response = await fetch(API_URL, {
            method: "POST",
            headers: HEADERS,
            body: JSON.stringify(userData),
        });

        if (!response.ok) {
            throw new Error(`Failed to add user: ${response.statusText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error adding user:", error);
        return { success: false, message: error.message };
    }
};

export const deleteUser = async (user) => {
    const API_URL = BASE_URL + "/users/delete";

    try {
        const response = await fetch(API_URL, {
            method: "DELETE",
            headers: HEADERS,
            body: JSON.stringify({ user }),
        });

        if (!response.ok) {
            throw new Error(`Failed to delete user: ${response.statusText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error deleting user:", error);
        return { success: false, message: error.message };
    }
};
